import { PAYMENT_TYPES } from '@vend/business-components'
import { Payment } from '../../models/payment'
import { Sale } from '../../models/sale'
import { ReduxCurrentSale } from '../../state/slices/currentSale/currentSaleSlice'
import { isReturn } from '../sale'

export const PAYPAL_ECOM_TYPE_ID = PAYMENT_TYPES.LIGHTSPEED_ECOM
export const PAYPAL_ECOM_TYPE_NAME = 'Paypal Standard (Online)'

/**
 * Determines if the given payment type id is Paypal Standard (Online)
 *
 * @param paymentTypeID The given payment type id.
 * @param paymentTypeName The given payment type name.
 *
 * @return True if the given payment type id and name is Lightspeed eCom, false otherwise.
 */
export const isPayPalEcomPaymentType = (
  paymentTypeID: number,
  paymentTypeName: string
): boolean => {
  return (
    PAYPAL_ECOM_TYPE_ID === paymentTypeID &&
    PAYPAL_ECOM_TYPE_NAME === paymentTypeName
  )
}

/**
 * Determines if the one of original sale payments in the sale is Lightspeed eCom.
 *
 * @param payments
 *        Payments on the original sale.
 *
 * @return {Boolean} True if a Lightspeed eCom payment exists in the collection, false otherwise.
 */
const hasPayPalEcomPayment = (payments: Payment[]): boolean => {
  return payments.some(payment => {
    return isPayPalEcomPaymentType(
      payment.paymentType.type_id,
      payment.paymentType.name
    )
  })
}

/**
 * Determines if the current sale is a Lightspeed eCom return.
 */
export const isReturnedEcomPayPalSale = (
  sale: Sale | ReduxCurrentSale
): boolean => {
  if (!isReturn(sale)) {
    return false
  }

  return hasPayPalEcomPayment(sale.originalSalePayments)
}
